import CollageEditor from '@/components/collage/CollageEditor';

const Index = () => {
  return <CollageEditor />;
};

export default Index;